exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginContainer {\n  height: 100%; }\n\n.login, button {\n  width: 280px; }\n\nform > md-input-container {\n  width: 100%; }\n\nmd-card-header {\n  height: 72px; }\n\nmd-card > md-card-header > img {\n  height: 72px;\n  width: 72px; }\n\nmd-card-actions,\nmd-card-footer {\n  text-align: center; }\n\nmd-card-title {\n  margin-top: 27px;\n  margin-left: 27px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/login/login.component.scss
// module id = ../../../../../src/app/components/login/login.component.scss
// module chunks = main